


















import { Button } from 'element-ui'
import { Vue, Prop, Component } from 'vue-property-decorator'

import EventBus from '@/event-bus'

@Component({
  components: {
    [Button.name]: Button,
  },
})
export default class TransferwisePaymentBody extends Vue {
  @Prop() paymentCode!: string
  @Prop() transferwiseTemplate!: string

  created() {
    EventBus.$emit('on-transferwise-payment-open')
  }
}
